(() => {
  const pageWrapper = document.querySelector('.page-wrapper');
  const siteHeader = pageWrapper?.querySelector('header') || document.querySelector('header');
  if (siteHeader && !document.querySelector('.omega-brand-announcement')) {
    const announcement = document.createElement('a');
    announcement.className = 'omega-brand-announcement';
    announcement.href = '/collections/all';
    announcement.setAttribute('aria-label', 'Free 30ml Pet Ear Cleaner with every online order. Free shipping RM50 and above in West Malaysia, RM80 and above in East Malaysia.');
    announcement.textContent = 'FREE 30ml Pet Ear Cleaner with every online order, while stocks last | Free shipping RM50+ West Malaysia | RM80+ East Malaysia';
    siteHeader.before(announcement);
  }

  const roots = document.querySelectorAll('[data-omega-catalog]');
  roots.forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-omega-product]'));
    const search = root.querySelector('[data-omega-search]');
    const result = root.querySelector('[data-omega-results]');
    const chips = Array.from(root.querySelectorAll('[data-omega-filter]'));
    let active = 'all';

    const refresh = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let shown = 0;
      cards.forEach((card) => {
        const category = card.dataset.category || '';
        const matchesCategory = active === 'all' || category === active;
        const matchesQuery = !query || (card.dataset.search || '').includes(query);
        card.hidden = !(matchesCategory && matchesQuery);
        if (!card.hidden) shown += 1;
      });
      if (result) result.textContent = `${shown} product${shown === 1 ? '' : 's'} shown`;
    };

    search?.addEventListener('input', refresh);
    chips.forEach((chip) => chip.addEventListener('click', () => {
      active = chip.dataset.omegaFilter || 'all';
      chips.forEach((button) => button.classList.toggle('is-active', button === chip));
      refresh();
    }));
    refresh();
  });

  document.querySelectorAll('[data-omega-journal-library]').forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-omega-journal-card]'));
    const search = root.querySelector('[data-omega-journal-search]');
    const result = root.querySelector('[data-omega-journal-results]');
    const empty = root.querySelector('[data-omega-journal-empty]');
    const filters = Array.from(root.querySelectorAll('[data-omega-journal-filter]'));
    const requested = new URLSearchParams(window.location.search).get('topic');
    let active = filters.some((button) => button.dataset.omegaJournalFilter === requested) ? requested : 'all';

    const refreshJournal = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let shown = 0;
      cards.forEach((card) => {
        const matchesTopic = active === 'all' || card.dataset.category === active;
        const matchesSearch = !query || (card.dataset.search || '').includes(query);
        card.hidden = !(matchesTopic && matchesSearch);
        if (!card.hidden) shown += 1;
      });
      filters.forEach((button) => button.classList.toggle('is-active', button.dataset.omegaJournalFilter === active));
      if (result) result.textContent = `${shown} article${shown === 1 ? '' : 's'} shown`;
      if (empty) empty.hidden = shown !== 0;
    };

    search?.addEventListener('input', refreshJournal);
    filters.forEach((button) => button.addEventListener('click', () => {
      active = button.dataset.omegaJournalFilter || 'all';
      const url = new URL(window.location.href);
      if (active === 'all') url.searchParams.delete('topic');
      else url.searchParams.set('topic', active);
      window.history.replaceState({}, '', url);
      refreshJournal();
    }));
    refreshJournal();
  });
})();


(() => {
  if (window.location.pathname === '/products/free-gift-omega-pets-pet-ear-cleaner-30ml') {
    window.location.replace('/collections/all');
    return;
  }

  const GIFT_VARIANT_ID = 55736579555619;
  const nativeFetch = window.fetch.bind(window);
  let syncingGift = false;
  let syncTimer;

  const announceCartRefresh = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  };

  const syncFreeGift = async () => {
    if (syncingGift) return;
    syncingGift = true;
    try {
      const cartResponse = await nativeFetch('/cart.js', { credentials: 'same-origin' });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const giftItem = cart.items.find((item) => Number(item.variant_id) === GIFT_VARIANT_ID);
      const hasQualifyingItem = cart.items.some((item) => Number(item.variant_id) !== GIFT_VARIANT_ID && item.quantity > 0);
      let changed = false;

      if (hasQualifyingItem && !giftItem) {
        const addResponse = await nativeFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: GIFT_VARIANT_ID,
              quantity: 1,
              properties: { '_Omega promotion': 'Free 30ml Pet Ear Cleaner — while stocks last' }
            }]
          })
        });
        changed = addResponse.ok;
      } else if (hasQualifyingItem && giftItem && giftItem.quantity !== 1) {
        const updateResponse = await nativeFetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 1 })
        });
        changed = updateResponse.ok;
      } else if (!hasQualifyingItem && giftItem) {
        const removeResponse = await nativeFetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        });
        changed = removeResponse.ok;
      }

      if (changed) announceCartRefresh();
    } catch (error) {
      console.warn('Omega free-gift sync skipped:', error);
    } finally {
      syncingGift = false;
    }
  };

  const scheduleGiftSync = (delay = 350) => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncFreeGift, delay);
  };

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const target = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(target)) scheduleGiftSync();
    return response;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleGiftSync(100));
  } else {
    scheduleGiftSync(100);
  }
  window.addEventListener('pageshow', () => scheduleGiftSync(100));
  document.addEventListener('click', (event) => {
    if (event.target.closest('button[name="add"], button[name="plus"], button[name="minus"], .quantity-plus, .quantity-minus, [data-cart-quantity], cart-drawer, .cart-drawer')) scheduleGiftSync(900);
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"], input[name="quantity"], [data-cart-quantity]')) scheduleGiftSync(500);
  }, true);
})();


(() => {
  const lockGiftQuantity = () => {
    document.querySelectorAll('[id*="CartItem-55736579555619"]').forEach((row) => {
      const plus = row.querySelector('button[name="plus"], .quantity-plus');
      const quantity = row.querySelector('input[name="updates[]"], input[name="quantity"]');
      if (plus) plus.disabled = true;
      if (quantity) { quantity.max = '1'; quantity.readOnly = true; }
    });
  };
  lockGiftQuantity();
  new MutationObserver(lockGiftQuantity).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(lockGiftQuantity, 1000);
})();
